// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import routes from './router'
import VueRouter from 'vue-router'
import axios from 'axios'
import Qs from 'qs'
import VueAxios from 'vue-axios'
import VuePaginate from 'vue-paginate'
import VueAnalytics from 'vue-analytics'
// import VueResource from 'vue-resource'

// import VueResource from 'vue-resource'
import store from './store'
import api from './api'
import bus from './api/bus'

// import './assets/application.js'
import '../static/scss/style.scss'

let axiosInstance = axios.create({
  transformRequest: [function (data) {
    data = Qs.stringify(data)
    return data
  }]
})

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(VueRouter)
Vue.use(VueAxios, axiosInstance)
Vue.use(VuePaginate)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes
})

Vue.use(VueAnalytics, {
  id: 'UA-105063209-1',
  router
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    next()
  } else {
    next()
  }
})

if (api) {
  console.log('Load Success')
}

/* eslint-disable */
new Vue({
  el: '#app',
  data(){
    return {
      bus:bus
    }
  },
  created: function () {
    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v2.10&appId=1903095033298686";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    window.fbAsyncInit = function () {
      FB.init({
        appId: '1903095033298686',
        cookie: true,
        xfbml: true,
        version: 'v11.0'
      })
      FB.AppEvents.logPageView()
    }
  },
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./src/main.js